import { LogLevel } from "@azure/msal-browser";
import { env } from "./utils/envConfig";
export const msalConfig = {
    auth:{
        clientId: env.REACT_APP_CLIENT_ID ?? '3044aef2-01be-4c57-8d2b-e8ae7b12b3dc',
        authority: env.REACT_APP_TENANT_ID?`https://login.microsoftonline.com/${env.REACT_APP_TENANT_ID}`:"https://login.microsoftonline.com/6e70803d-1d06-4a7f-964c-b357505dae97",
        // MSAL v5 requires the redirectUri to serve the redirect bridge page.
        // The /redirect path is handled in index.tsx before MSAL initializes;
        // deployed envs set REACT_APP_REDIRECT_URL to <origin>/redirect.
        redirectUri: env.REACT_APP_REDIRECT_URL || `${window.location.origin}/redirect`,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
        }
    }
}

export const loginRequest = {
      scopes: [ "openid", "profile", "User.Read" ],
 };
export const tokenRequest = {
    scopes: [`${env.REACT_APP_CLIENT_ID}/.default`]
};
